import { createStore } from 'vuex'
import userInfo from './module/userInfo'
import business from './module/business'
import permissions from './module/permissions'
import getters from "*";
export default createStore({
  state: {
    isCollapse: false, // 侧边栏展开收起
      // baeUrl:'http://localhost:18089', // 本地地址
      // baeUrl: 'http://192.168.1.117:9003', //本地环境域名
      // baeUrl:'http://ghltest.mxktech.cn:8089', // 服务器地址
      baeUrl:'http://wmstest.mxktech.cn', // 测试地址
      // baeUrl:'http://221.239.35.195:81', // 正式地址
      // oaUrl: 'http://oa.com', //本地环境
      // domain: 'http://192.168.1.117:9003' //本地环境域名
      // oaUrl: 'https://oa.ghatgsupply.com', //正式环境老系统域名
      domain:'http://wmstest.mxktech.cn', // 测试地址
      // domain:'http://221.239.35.195:81', // 正式地址



  },
  mutations: {
    setIsCollapse (state) {
      state.isCollapse = !state.isCollapse
    }
  },
  getters: {},
  actions: {},
  modules: {
    userInfo,
    permissions,
    business
  }

})
